
import React from 'react';
import OnboardingStepIndicator from '@/components/onboarding/OnboardingStepIndicator';

interface BusinessOnboardingStepsProps {
  currentStep: number;
}

const BusinessOnboardingSteps: React.FC<BusinessOnboardingStepsProps> = ({ currentStep }) => {
  return (
    <OnboardingStepIndicator 
      steps={[
        { number: 1, label: "Account" },
        { number: 2, label: "Referral Setup" },
        { number: 3, label: "Complete" }
      ]} 
      currentStep={currentStep}
    />
  );
};

export default BusinessOnboardingSteps;
